import React, { useState, useEffect, useContext, useRef } from "react";
import GoBack from "../../components/goBack";
import Select from "react-select";
import axios from "axios";
import $ from "jquery";
import { baseURL } from "../../services/api";
import OrgContext from "../../organisation/OrgContext";
import AuthContext from "../../components/shared/AuthContext";
import Swal from "sweetalert2";
import { useTranslation } from "react-i18next";
import { toast, ToastContainer } from "react-toastify";
import moment from "moment/moment";
import NewClient from "../Items/NewClient";
import useAuthHelper from "../../helpers/AuthHelper";
import { useNavigate } from "react-router-dom";

export const NewBoncommande = () => {
  const { organisation } = useContext(OrgContext);
  const { user } = useContext(AuthContext);
  const [t] = useTranslation();

  const navigate = useNavigate();
  // State variables
  const [suppliers, setSuppliers] = useState([]);
  const [products, setProducts] = useState([]);
  const [selectedSupplier, setSelectedSupplier] = useState(null);
  const [orderProducts, setOrderProducts] = useState([]);
  const [orderDate, setOrderDate] = useState(moment().format("YYYY-MM-DD"));
  const [dueDate, setDueDate] = useState(moment().format("YYYY-MM-DD"));
  const [isSubmit, setIsSubmit] = useState(false);

  // Modal states
  const [productIdToEdit, setProductIdToEdit] = useState(0);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [qty, setQty] = useState(0);
  const [unitPrice, setUnitPrice] = useState(0);
  const [totalHt, setTotalHt] = useState(0);
  const [totalTtc, setTotalTtc] = useState(0);
  const [tva, setTva] = useState(0);
  const [productDetails, setProductDetails] = useState("");
  const leTotalHt = useRef(0);
  const leTotalTtc = useRef(0);
  const [singleSelectedProduct, setSingleSelectedProduct] = useState([]);
  const [isService, setIsService] = useState(false);
  const [invoiceProductsState, setInvoiceProductsState] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const [selectedProductQty, setSelectedProductQty] = useState(0);
  const [totalTTc, setTotalTTC] = useState();
  const [title, setTitle] = useState("");

  const leTotalTTc = useRef(0);
  //summary
  const [summaryTotatlHt, setSummaryTotalHt] = useState(0);
  const [summaryTotalTva, setSummaryTotalTva] = useState(0);
  const [summaryTotatlTtc, setSummaryTotalTtc] = useState(0);

  const [selectedDepotId, setSelectedDepotId] = useState(0);
  // Fetch suppliers
  const fetchSuppliers = async () => {
    try {
      const response = await axios.get(
        `${baseURL}/client/getbyuser/${user.id}/fournisseurs/${organisation.id}`,
      );
      setSuppliers(
        response.data.data.map((s) => ({
          value: s.id,
          label: s.companyName + " - " + s.account.code,
        })),
      );
    } catch (error) {
      console.error(error);
    }
  };

  // Fetch products
  const fetchProducts = async () => {
    try {
      const response = await axios.get(
        `${baseURL}/product/getbyuser/${user.id}/${organisation.id}`,
      );
      setProducts(
        response.data.data.map((p) => ({
          value: p.id,
          label: p.name,
          tva: p.taxe_achat.rate,
          unitPrice: p.costPrice,
          type: p.type,
          purchaseAccount: p.purchase_account,
          purchaseAccountCode: p.purchase_account_code,
          depot: p.depot,
          isService: p.type === "Services",
        })),
      );
    } catch (error) {
      console.error(error);
    }
  };

  // Reset modal fields
  const resetModalFields = () => {
    setSelectedProduct(null);
    setQty(0);
    setUnitPrice(0);
    setTotalHt(0);
    setTotalTtc(0);
    setTva(0);
    setProductDetails("");
  };

  // Hide modal
  const hideModal = () => {
    document.getElementById("productModal").classList.remove("show");
    document.querySelector(".modal-backdrop").remove();
  };

  // Update summary
  const updateSummary = (products) => {
    let totalHt = 0;
    let totalTva = 0;
    let totalTtc = 0;

    products.forEach((product) => {
      totalHt += product.totalHt;
      totalTva += product.totalTtc - product.totalHt;
      totalTtc += product.totalTtc;
    });

    setSummaryTotalHt(totalHt.toFixed(2));
    setSummaryTotalTva(totalTva.toFixed(2));
    setSummaryTotalTtc(totalTtc.toFixed(2));
  };

  function generateReference() {
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let reference = "";
    for (let i = 0; i < 6; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      reference += characters[randomIndex];
    }
    return reference;
  }
  // Save order
  const saveOrder = async () => {
    if (!selectedSupplier || invoiceProductsState.length === 0) {
      toast.error(t("Veuillez remplir tous les champs obligatoires !"));
      return;
    }

    const payload = {
      user_id: user.id,
      organisation_id: organisation.id,
      // supplier_id: selectedSupplier.value,
      order_date: orderDate,
      due_date: dueDate,
      total_ht: summaryTotatlHt,
      total_tva: summaryTotalTva,
      total_ttc: summaryTotatlTtc,
      title: title,
      fournisseur_id: selectedSupplier.value,
      products: invoiceProductsState.map((p) => ({
        product_id: p.product_id,
        qty: p.qty,
        price_unit_ht: p.unitPrice,
        total_ht: p.totalHt,
        total_ttc: p.totalTtc,
        details: p.details,
        tva: p.tva,
        reference: generateReference(),
        depot_id: p.depot_id || 0, // Ensure depot_id is included
      })),
    };

    setIsSubmit(true);
    try {
      await axios.post(`${baseURL}/data/bon-commande/add`, payload);
      Swal.fire(t("Le bon de commande a été créé avec succès."), "", "success");
      navigate("/achats/boncommande/list");
    } catch (error) {
      console.error(error);
    } finally {
      setIsSubmit(false);
    }
  };

  useEffect(() => {
    fetchSuppliers();
    fetchProducts();
    setTitle(`BC-${Math.floor(Math.random() * 100000)}`);
  }, []);

  const onSaveClient = () => {
    fetchSuppliers();
    window.$("#newClientModal").modal("hide");
    console.log("has been saved");
    Swal.fire(t("Le client a été ajouter avec succès"), t(""), "success");
  };
  useEffect(() => {
    calcInvoiceSummary(invoiceProductsState);
  }, [invoiceProductsState]);

  const calcInvoiceSummary = (invoiceProducts) => {
    let totalHt = 0;
    let totalTva = 0;
    let totalTtc = 0;

    for (let i = 0; i < invoiceProductsState.length; i++) {
      totalHt += parseFloat(invoiceProductsState[i].totalHt);
      totalTtc += parseFloat(invoiceProductsState[i].totalTtc);
      totalTva +=
        parseFloat(invoiceProductsState[i].totalTtc) -
        parseFloat(invoiceProductsState[i].totalHt);
    }
    setSummaryTotalHt(totalHt);
    setSummaryTotalTva(totalTva);
    setSummaryTotalTtc(totalTtc);
  };
  const deleteSingleProduct = (productId) => {
    for (let i = 0; i < invoiceProductsState.length; i++) {
      if (invoiceProductsState[i].product_id === productId) {
        invoiceProductsState.splice(i, 1);
        console.log("spliced");
      }
    }
    setInvoiceProductsState([...invoiceProductsState]);
  };
  const editSingleProduct = (productId) => {
    $(".select-article").css("display", "none");
    $(".add-new-product-to-invoice-btn").css("display", "none");
    $(".edit-single-product").css("display", "revert");
    setProductIdToEdit(productId);
    let selectedProduct = invoiceProductsState.filter(
      (p) => p.product_id === productId,
    );
    console.log("product", selectedProduct);
    setProductDetails(selectedProduct[0].details);
    setIsService(selectedProduct[0].type === "Services");
    setQty(selectedProduct[0]["qty"]);
    setUnitPrice(selectedProduct[0]["unitPrice"]);
    setTva(selectedProduct[0]["tva"]);
    setSelectedDepotId(selectedProduct[0].depot_id || 0);
  };
  const changeOfCanvasLayouts = () => {
    $("#all-fields-are-required").css("display", "none");
    $(".select-article").css("display", "block");
    $(".add-new-product-to-invoice-btn").css("display", "inline");
    $(".edit-single-product").css("display", "none");
    emptyInputs();
  };
  const [showRequiredFieldsAlert, setShowRequiredFieldsAlert] = useState(false);
  const [showProductExistsAlert, setShowProductExistsAlert] = useState(false);

  const addNewProductToInvoice = async () => {
    // Reset alerts
    setShowRequiredFieldsAlert(false);
    setShowProductExistsAlert(false);

    if (
      !singleSelectedProduct?.value ||
      qty === 0 ||
      unitPrice === 0 ||
      leTotalHt.current.value === "0.00" ||
      leTotalTTc.current.value === "0.00"
    ) {
      setShowRequiredFieldsAlert(true);
      return;
    }

    if (checkIfProductAlreadyExist(singleSelectedProduct.value)) {
      setShowProductExistsAlert(true);
      return;
    }

    hideOffcanvas();

    const product = {
      product_id: singleSelectedProduct.value,
      name: `${singleSelectedProduct.label} - ${productDetails}`,
      isService: singleSelectedProduct.isService,
      compte_de_charge: singleSelectedProduct.purchaseAccount,
      code: singleSelectedProduct.purchaseAccountCode,
      type: singleSelectedProduct.type,
      qty: qty,
      unitPrice: unitPrice,
      tva: tva,
      totalHt: leTotalHt.current.value,
      totalTtc: leTotalTTc.current.value,
      details: productDetails,
      depot_id: parseInt(selectedDepotId) || 0, // Ensure depot_id is included
    };

    setInvoiceProductsState([...invoiceProductsState, product]);
    setProductDetails("");
  };
  useEffect(() => {
    console.log("selected", selectedDepotId);
  }, [selectedDepotId]);
  const checkIfProductAlreadyExist = (productId) => {
    for (let i = 0; i < invoiceProductsState.length; i++) {
      if (invoiceProductsState[i].product_id === productId) {
        console.log("exist");
        return true;
      }
    }
    console.log("! exist");
    return false;
  };
  const emptyInputs = () => {
    setSingleSelectedProduct([]);
    setSelectedProduct([]);
    setQty(0);
    setUnitPrice("");
    setTva(0);
    setTotalHt("");
    setTotalTTC("");
    setIsService(false);
  };
  const getProductData = async (selectedProduct) => {
    //selectedProduct
    const response = await axios
      .get(baseURL + `/product/get/${selectedProduct.value}`)
      .then((response) => {
        // setSingleSelectedProduct(transformProductsArray(response.data.data))
        setUnitPrice(response.data.data[0]["costPrice"]);
        if (selectedProduct?.isService) {
          setIsService(true);
          setQty(1);
        } else {
          setQty(0);
        }
        console.log(
          "response.data.dataresponse.data.dataresponse.data.data: ",
          response.data.data,
        );
        setSelectedProductQty(response.data.data.qty);
        setTva(response.data.data[0]["taxe_achat"].rate);
      })
      .catch((error) => console.log("error " + error));
  };
  const hideOffcanvas = () => {
    const offcanvasElement = document.getElementById("offcanvasBottom");

    const offcanvas =
      window.bootstrap?.Offcanvas.getInstance(offcanvasElement) ||
      new window.bootstrap.Offcanvas(offcanvasElement);

    offcanvas.hide();
  };
  const editSingleInvoiceProduct = () => {
    if (
      // selectedProduct.value === null ||
      qty === 0 ||
      unitPrice === 0 ||
      leTotalHt.current.value === 0 ||
      leTotalTTc.current.value === 0
    ) {
      toast.error("Tous les champs sont obligatoire !", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    } else {
      hideOffcanvas();
      for (let i = 0; i < invoiceProductsState.length; i++) {
        if (invoiceProductsState[i].product_id === productIdToEdit) {
          invoiceProductsState[i].qty = qty;
          invoiceProductsState[i].unitPrice = unitPrice;
          invoiceProductsState[i].totalHt = leTotalHt.current.value;
          invoiceProductsState[i].totalTtc = leTotalTTc.current.value;
          invoiceProductsState[i].details = productDetails;
          invoiceProductsState[i].tva = tva;
          invoiceProductsState[i].depot_id = parseInt(selectedDepotId) || 0; // Ensure depot_id is included
        }
        setInvoiceProductsState([...invoiceProductsState]);
      }
    }
  };

  const { onlyCommercial, hadAddAccess } = useAuthHelper();

  useEffect(() => {
    onlyCommercial();
    hadAddAccess();
    $(".all-fields-are-required-to-save").css("display", "none");
    $("#warning-create-client-first").css("display", "none");
    $("#table-rows").css("display", "none");
    $("#all-fields-are-required").css("display", "none");
    $("#warning-product-already-exists").css("display", "none");
    $("#qty-is-higher").css("display", "none");
    $(".some-fields-are-required-to-save").css("display", "none");
  }, []);
  useEffect(() => {
    console.log("invoiceProductsState", singleSelectedProduct);
  }, [singleSelectedProduct]);
  return (
    <>
      <ToastContainer />
      <div className="main-container container-fluid">
        <GoBack route={"/achats/boncommande/list"} />
        <div className="page-header">
          <h1 className="page-title">{t("Créer un Bon de Commande")}</h1>
        </div>
        <div className="card">
          <div
            class="modal fade"
            id="newClientModal"
            tabIndex="-1"
            aria-labelledby="newClientModalLabel"
            aria-hidden="true"
          >
            <div class="modal-dialog modal-xl">
              <div class="modal-content">
                <div class="modal-header">
                  <h1 class="modal-title fs-5" id="newClientModal">
                    Ajouter un nouveaux fournisseur
                  </h1>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>
                <div class="modal-body">
                  <NewClient
                    clientType={"fournisseurs"}
                    from={"new_fv"}
                    handleSave={onSaveClient}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="card-body">
            <h4>{t("Espace Fournisseur")}</h4>
            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label>{t("Fournisseur")}</label>
                  <Select options={suppliers} onChange={setSelectedSupplier} />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label htmlFor="exampleInputEmail1" className="">
                    Nouveau fournisseur
                  </label>
                  <a
                    className="btn btn-primary form-control"
                    data-bs-toggle="modal"
                    data-bs-target="#newClientModal"
                  >
                    <i className="fe fe-user"></i> ajouter un fournisseur
                  </a>
                </div>
              </div>
            </div>
            <hr />
            <h4>{t("Informations sur la facture")}</h4>
            <hr />
            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label>{t("Numéro de bon de commande")}</label>
                  <input
                    type="text"
                    className="form-control"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label>{t("Date bon de commande")}</label>
                  <input
                    type="date"
                    className="form-control"
                    value={orderDate}
                    onChange={(e) => setOrderDate(e.target.value)}
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label>{t("Date date d'échéance*")}</label>
                  <input
                    type="date"
                    className="form-control"
                    value={dueDate}
                    onChange={(e) => setDueDate(e.target.value)}
                  />
                </div>
              </div>
            </div>
            <hr />
            <h4>{t("Details Produits")}</h4>
            <hr />
            <table className="table">
              <thead>
                <tr>
                  <th scope="col">DÉTAILS DE L’ARTICLE</th>
                  <th scope="col">QUANTITÉ</th>
                  <th scope="col">PU HT</th>
                  <th scope="col">TVA %</th>
                  <th scope="col">Total HT</th>
                  <th scope="col">Total TTC</th>
                  <th scope="col"></th>
                  <th scope="col"></th>
                </tr>
              </thead>
              {invoiceProductsState.map((product) => {
                return (
                  <tr key={product.product_id}>
                    <td>{product.name}</td>
                    <td>{product.qty}</td>
                    <td>{product.unitPrice}</td>
                    <td>{product.tva + "%"}</td>
                    <td>{product.totalHt}</td>
                    <td>{product.totalTtc}</td>
                    <td>
                      <i
                        onClick={() => deleteSingleProduct(product.product_id)}
                        className="fe fe-trash"
                      ></i>
                    </td>
                    <td>
                      <i
                        data-bs-toggle="offcanvas"
                        aria-controls="offcanvasBottom"
                        data-bs-target="#offcanvasBottom"
                        onClick={() => {
                          console.log("product", product.product_id);
                          setIsService(product.isService);
                          editSingleProduct(product.product_id);
                        }}
                        className="fe fe-edit"
                      ></i>
                    </td>
                  </tr>
                );
              })}
            </table>
            <center>
              <button
                onClick={changeOfCanvasLayouts}
                className="btn btn-primary off-canvas btn-sm mb-1"
                type="button"
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasBottom"
                aria-controls="offcanvasBottom"
              >
                <i className="fe fe-plus"></i>
                ajouter un article
              </button>
            </center>

            <hr className={"custom-hr"} />
            <div className={"row"}>
              <div className={"col-md-6"}></div>
              <div className={"col-md-6 d-flex flex-row-reverse"}>
                <div className="row">
                  <div className="invoiceSummary">
                    <table>
                      <tr>
                        <td className={"invoiceSummary-base"}>Total HT :</td>
                        <td>
                          {Number(summaryTotatlHt).toFixed(2)}{" "}
                          {organisation?.currency?.code}
                        </td>
                      </tr>
                      <tr>
                        <td className={"invoiceSummary-base"}>Total TVA :</td>
                        <td>
                          {" "}
                          {Number(summaryTotalTva).toFixed(2)}{" "}
                          {organisation?.currency?.code}
                        </td>
                      </tr>
                      <tr>
                        <td className={"invoiceSummary-base"}>Total TTC :</td>
                        <td>
                          {" "}
                          {Number(summaryTotatlTtc).toFixed(2)}{" "}
                          {organisation?.currency?.code}
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <button
              className="btn btn-success"
              onClick={saveOrder}
              disabled={isSubmit}
            >
              {isSubmit ? t("Enregistrement...") : t("Enregistrer")}
            </button>
          </div>
        </div>
      </div>

      <div
        className="offcanvas offcanvas-bottom addProductCanvas"
        tabIndex="-1"
        id="offcanvasBottom"
        aria-labelledby="offcanvasBottomLabel"
      >
        <div className="offcanvas-header">
          <h5 className="offcanvas-title" id="offcanvasBottomLabel">
            Renseigner le produit à ajouter.
          </h5>
          <button
            type="button"
            className="btn-close text-reset"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          >
            <i className="fe fe-x fs-18"></i>
          </button>
        </div>
        <div className="offcanvas-body">
          {showRequiredFieldsAlert && (
            <div
              className="alert alert-danger alert-dismissible fade show mb-0"
              role="alert"
            >
              <span className="alert-inner--icon">
                <i className="fe fe-slash"></i>
              </span>
              <span className="alert-inner--text">
                <strong>Attention!</strong> Tous les champs sont obligatoires !
              </span>
            </div>
          )}

          {showProductExistsAlert && (
            <div
              className="alert alert-danger alert-dismissible fade show mb-0"
              role="alert"
            >
              <span className="alert-inner--icon">
                <i className="fe fe-slash"></i>
              </span>
              <span className="alert-inner--text">
                <strong>Attention!</strong> Le produit existe déjà !
              </span>
            </div>
          )}

          <form className="needs-validation" noValidate="">
            <div class="form-row">
              <div class="col-xl-12 mb-3">
                <label
                  className={"select-article"}
                  htmlFor="validationTooltip01"
                >
                  DÉTAILS DE L’ARTICLE*
                </label>
                <Select
                  value={singleSelectedProduct}
                  className={"select-article"}
                  options={products}
                  onChange={(choice) => {
                    setSingleSelectedProduct(choice);
                    getProductData(choice);
                    setUnitPrice(choice.unitPrice);
                  }}
                />
              </div>
              <div class="col-xl-12 mb-3">
                <label htmlFor="productDetails">Détails du produit</label>
                <textarea
                  className="form-control"
                  id="productDetails"
                  rows="2"
                  value={productDetails}
                  onChange={(e) => setProductDetails(e.target.value)}
                ></textarea>
              </div>
              <div
                className="col-xl-12 mb-3"
                hidden={!singleSelectedProduct?.depot?.length || isService}
              >
                {singleSelectedProduct?.depot?.length > 0 && (
                  <>
                    <label htmlFor="productDepots">
                      {"Dépôts disponibles"}
                    </label>
                    {singleSelectedProduct?.depot?.map((depot, index) => (
                      <div key={index} className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          id={`depot-${index}`}
                          value={depot.depot_id}
                          checked={selectedDepotId == depot.depot_id}
                          name="productDepot"
                          onChange={(e) => {
                            setSelectedDepotId(e.target.value);

                            console.log("productDepot", e.target.value);
                          }}
                        />
                        <label
                          className="form-check-label"
                          htmlFor={`depot-${index}`}
                        >
                          {depot.depot.name}
                        </label>
                      </div>
                    ))}
                  </>
                )}
              </div>
              <div className="col-xl-3 mb-3" hidden={isService}>
                <label htmlFor="validationTooltip02">QUANTITÉ*</label>
                <input
                  className="form-control"
                  id="validationTooltip02"
                  type="number"
                  required
                  value={qty}
                  onChange={(e) => {
                    // Parse the quantity to a float and handle negative values
                    const inputValue = parseFloat(
                      parseFloat(e.target.value).toFixed(2),
                    );

                    // Vérifie si la valeur saisie est un nombre valide
                    if (isNaN(inputValue) || inputValue < 0) {
                      setQty(""); // Réinitialise la quantité en cas de saisie invalide
                      setTotalHt("0.00");
                      setTotalTTC("0.00");
                      return;
                    }

                    // Vérifie si la quantité dépasse le stock disponible
                    if (inputValue > selectedProductQty) {
                      setQty(inputValue);
                      setTotalHt("0.00");
                      setTotalTTC("0.00");
                      return;
                    }

                    // Calcule les valeurs
                    const totalHtl = (inputValue * unitPrice).toFixed(2);
                    const totalTTC = (
                      parseFloat(totalHtl) +
                      (parseFloat(totalHtl) * tva) / 100
                    ).toFixed(2);

                    // Met à jour l'état
                    setQty(inputValue);
                    setTotalHt(totalHtl);
                    setTotalTTC(totalTTC);
                  }}
                />
              </div>
              <div class="col-xl-3 mb-3">
                <label htmlFor="validationTooltip02">PU HT*</label>
                <input
                  type="number"
                  className="form-control"
                  id="validationTooltip02"
                  // required=""
                  value={unitPrice}
                  onChange={(e) => {
                    const value = parseFloat(e.target.value);
                    if (!isNaN(value)) {
                      let total_ht = qty * value;
                      let total_ttc = (
                        parseFloat(total_ht) +
                        (parseFloat(total_ht) * tva) / 100
                      ).toFixed(2);
                      setUnitPrice(parseFloat(value.toFixed(2)));
                      setTotalHt(parseFloat(total_ht.toFixed(2)));
                      setTotalTTC(total_ttc);
                    }
                  }}
                  // disabled={!isService}
                />
              </div>
              <div className="col-xl-3 mb-3">
                <label htmlFor="validationTooltip02">Total HT*</label>
                <input
                  type="text"
                  className="form-control"
                  id="validationTooltip02"
                  required=""
                  value={isService ? unitPrice.toFixed(2) : totalHt}
                  ref={leTotalHt}
                />
              </div>
              <div className="col-xl-3 mb-3">
                <label htmlFor="validationTooltip02">Total TTC*</label>
                <input
                  type="number"
                  className="form-control"
                  id="validationTooltip02"
                  required=""
                  value={
                    isService
                      ? (
                          parseFloat(unitPrice.toFixed(2)) +
                          (parseFloat(unitPrice.toFixed(2)) * tva) / 100
                        ).toFixed(2)
                      : totalTTc
                  }
                  ref={leTotalTTc}
                />
              </div>
            </div>
            <i
              className="fe fe-plus btn btn-primary add-new-product-to-invoice-btn"
              onClick={addNewProductToInvoice}
            ></i>
            <i
              className="fe fe-edit btn btn-primary edit-single-product"
              onClick={editSingleInvoiceProduct}
            ></i>
          </form>
        </div>
      </div>
    </>
  );
};
